import * as React from 'react';
import { useSelector } from 'react-redux';

import { dynamicCalltracking } from '../../services/dynamicCalltracking';
import { TPlaceType } from '../../types/calltracking';
import { selectSiteBlockIdByOfferId } from '../../selectors/calltracking';
import { selectOfferGaLabel } from '../../selectors/offers';
import { CallButton } from '../../components/CallButton';
import { TPhoneOpenActionType, trackPhoneOpen } from './tracking';
import { useOfferContext } from '../../utils/offerContext';

interface ICallButtonFieldContainerProps {
  placeType: TPlaceType;
  action: TPhoneOpenActionType;
  buttonIcon?: React.ReactElement<any>;
}

export const CallButtonContainer: React.FC<ICallButtonFieldContainerProps> = ({ placeType, action, buttonIcon }) => {
  const [dynamicPhone, setDynamicPhone] = React.useState<string>('');
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const {
    id,
    published,
    contacts: { formattedPhone: phone },
  } = useOfferContext();
  const siteBlockId = useSelector(selectSiteBlockIdByOfferId(id));
  const label = useSelector(selectOfferGaLabel(id));

  const handlePhoneOpen = React.useCallback(
    async (e: React.SyntheticEvent<HTMLButtonElement>) => {
      e.persist();
      e.stopPropagation();
      const response = await dynamicCalltracking({
        siteBlockId,
        placeType,
        announcementId: id,
      });

      trackPhoneOpen({ action, label, offerId: id });

      setDynamicPhone(response.phone || phone);
      setIsOpen(true);
    },
    [siteBlockId, placeType, id, phone, action, label],
  );

  if (phone && phone.length > 0) {
    return (
      <CallButton
        disabled={!published}
        phone={dynamicPhone}
        isOpen={isOpen}
        onClick={handlePhoneOpen}
        buttonIcon={buttonIcon}
      />
    );
  }

  return null;
};
